import {
  ADMIN_CLIENTS_GET_ALL_REQUESTING,
  ADMIN_CLIENTS_GET_ALL_SUCCESS,
  ADMIN_CLIENTS_GET_ALL_ERROR,
  ADMIN_SET_FAKE_DATA
} from "./constants";

import { CLIENT_GET_SUCCESS } from "../client/constants";

import { AUTH_LOGOUT_SUCCESS } from "../auth/reducer";

const initialState = {
  clients: [],
  fakeData: {},
  isFakeData: false,
  error: null,
  requesting: false
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ADMIN_CLIENTS_GET_ALL_SUCCESS: {
      return { ...state, clients: action.payload, requesting: false };
    }

    case ADMIN_CLIENTS_GET_ALL_ERROR: {
      return { ...state, error: action.payload, requesting: false };
    }

    case ADMIN_CLIENTS_GET_ALL_REQUESTING: {
      return {
        ...state,
        requesting: true
      };
    }

    case ADMIN_SET_FAKE_DATA: {
      return {
        ...state,
        fakeData: action.payload,
        isFakeData: true
      };
    }

    case CLIENT_GET_SUCCESS:
      return {
        ...state,
        isFakeData: false
      };

    case AUTH_LOGOUT_SUCCESS:
      return initialState;

    default:
      return state;
  }
};

export default reducer;
